const mutations = {
  GET_USUARIO(state) {
    return state.usuario;
  },

  SET_USUARIO(state, usuario) {
    state.usuario = usuario;
  },
};

export default mutations;
